import BraintreeWebClient from 'braintree-web/client'

import { doApi } from 'services/api'

const getBraintreeClientToken = async (flushToken, isAnon) => {
  if (!flushToken && localStorage.getItem('braintreeClientToken')) {
    return localStorage.getItem('braintreeClientToken')
  }
  else {
    const input = isAnon ? {route: `braintreeclienttokenanon`, noAuth: true} : {route: `braintreeclienttoken`}
    const newToken = await doApi(input)
    localStorage.setItem('braintreeClientToken', newToken.clientToken)
    return newToken.clientToken
  }
};

export const getBraintreeClientInstance = async (isAnon) => {
  const braintreeClientToken = await getBraintreeClientToken(false, isAnon)

  let newClient
  try {
    newClient = await BraintreeWebClient.create({authorization: braintreeClientToken})
  }
  catch (err) {
    // get fresh token in case it was expired
    console.log(err)
    const newToken = await getBraintreeClientToken(true, isAnon)
    newClient = await BraintreeWebClient.create({authorization: newToken})
  }

  return newClient;
};

export const getGiftDetails = async (pid, rid, testWithActiveCard) => {
  return (await doApi({route: `giftdetails?pid=${pid}&rid=${rid}` + (testWithActiveCard ? '&test=Y' : ''),
                       noBrowseAsUser: true,
                       noAuth: true})).success.giftDetails
};

export const savePaymentMethod = async (revenueLookupIdArray, nonce, associatedGifts, primaryEmail, testSuccessEmail) => {
  return await doApi({route: `braintreesavecard`, method: 'POST', noBrowseAsUser: true, data: {revenueLookupIdArray, nonce, associatedGifts, primaryEmail, testSuccessEmail}});
};

export const savePaymentMethodAnon = async (revenueLookupIdArray, nonce, associatedGifts, publicId, testSuccessEmail) => {
  console.log("savePaymentMethodAnon", {revenueLookupIdArray, nonce, associatedGifts, publicId, testSuccessEmail})
  return await doApi({route: `braintreesavecardanon`, method: 'POST', noBrowseAsUser: true, noAuth: true, data: {revenueLookupIdArray, nonce, associatedGifts, publicId, testSuccessEmail}});
};